import classNames from 'classnames'
import { h } from 'preact'

export interface IconProps {
    class?: string
}

export const ArrowDownIcon = (props: IconProps) => (
    <svg class={classNames('icon', props.class)} viewBox="0 0 9.41 6.12">
        <path d="M1.41 0l3.3 3.29L8 0l1.41 1.41-4.7 4.71L0 1.41z" />
    </svg>
)

export const ArrowRightIcon = (props: IconProps) => (
    <svg class={classNames('icon', props.class)} viewBox="0 0 6.12 9.41">
        <polygon points="1.41 9.41 0 8 3.29 4.71 0 1.41 1.41 0 6.12 4.71 1.41 9.41" />
    </svg>
)

export const CheckIcon = (props: IconProps) => (
    <svg class={props.class} viewBox="0 0 16 12" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M1.5 5.65385L6.362 10.5L14.5 1.5" />
    </svg>
)

export const LbCloseIcon = (props: IconProps) => (
    <svg class={classNames('icon', props.class)} viewBox="0 0 15.93 15.96">
        <polygon points="15.93 0.71 15.23 0 7.96 7.27 0.71 0.02 0 0.73 7.25 7.98 0 15.23 0.71 15.93 7.96 8.69 15.23 15.96 15.93 15.25 8.66 7.98 15.93 0.71" />
    </svg>
)

export const MinusIcon = (props: IconProps) => (
    <svg class={classNames('icon', props.class)} viewBox="0 0 14 2">
        <path d="M14 2H0V0H14V2Z" />
    </svg>
)

export const PageLeftIcon = (props: IconProps) => (
    <svg class={classNames('icon', props.class)} viewBox="0 0 13 14">
        <path d="M7.05252 12.9428C7.19581 12.7995 7.2763 12.6052 7.2763 12.4026C7.2763 12.1999 7.19581 12.0056 7.05252 11.8623L2.95198 7.76176L11.9148 7.76716C12.1183 7.76716 12.3134 7.68634 12.4573 7.54247C12.6012 7.3986 12.682 7.20346 12.682 7C12.682 6.79654 12.6012 6.6014 12.4573 6.45753C12.3134 6.31366 12.1183 6.23284 11.9148 6.23284L2.95198 6.23824L7.05252 2.1377C7.1958 1.99441 7.2763 1.80008 7.2763 1.59744C7.2763 1.39481 7.1958 1.20047 7.05252 1.05718C6.90923 0.9139 6.7149 0.833403 6.51226 0.833403C6.30963 0.833403 6.11529 0.9139 5.97201 1.05718L0.569449 6.45974C0.499704 6.5312 0.444641 6.61563 0.407374 6.70826C0.330185 6.89509 0.330185 7.1049 0.407373 7.29174C0.444641 7.38437 0.499704 7.4688 0.569449 7.54025L5.97201 12.9428C6.11529 13.0861 6.30963 13.1666 6.51226 13.1666C6.7149 13.1666 6.90924 13.0861 7.05252 12.9428Z" />
    </svg>
)

export const PageRightIcon = (props: IconProps) => (
    <svg class={classNames('icon', props.class)} viewBox="0 0 13 14">
        <path d="M5.97678 1.05719C5.83349 1.20047 5.75299 1.39481 5.75299 1.59744C5.75299 1.80008 5.83349 1.99441 5.97678 2.1377L10.0773 6.23824L1.11447 6.23284C0.911009 6.23284 0.715878 6.31366 0.572007 6.45753C0.428136 6.6014 0.347311 6.79654 0.347311 7C0.347311 7.20346 0.428136 7.3986 0.572008 7.54247C0.715879 7.68634 0.91101 7.76716 1.11447 7.76716L10.0773 7.76176L5.97678 11.8623C5.83349 12.0056 5.753 12.1999 5.753 12.4026C5.753 12.6052 5.83349 12.7995 5.97678 12.9428C6.12006 13.0861 6.3144 13.1666 6.51703 13.1666C6.71967 13.1666 6.914 13.0861 7.05729 12.9428L12.4598 7.54026C12.5296 7.4688 12.5847 7.38437 12.6219 7.29174C12.6991 7.10491 12.6991 6.8951 12.6219 6.70826C12.5847 6.61563 12.5296 6.5312 12.4598 6.45975L7.05729 1.05719C6.914 0.913901 6.71967 0.833404 6.51703 0.833404C6.3144 0.833404 6.12006 0.913902 5.97678 1.05719Z" />
    </svg>
)

export const PlusIcon = (props: IconProps) => (
    <svg class={classNames('icon', props.class)} viewBox="0 0 14 14">
        <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" />
    </svg>
)

export const RemoveIcon = (props: IconProps) => (
    <svg class={classNames('icon', props.class)} viewBox="0 0 9.4 9.4">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.7 3.3L1.4 0 0 1.4l3.3 3.3L0 8l1.4 1.4 3.3-3.3L8 9.4 9.4 8 6.1 4.7l3.3-3.3L8 0 4.7 3.3z"
        />
    </svg>
)

export const SeatIcon = (props: IconProps) => (
    <svg class={classNames('icon', props.class)} viewBox="0 0 17.1 18">
        <path d="M16.5 9.4c-.2 2-1.9 3.6-4 3.6h-8c-2 0-3.8-1.5-4-3.6l-.5-5C-.2 2.1 1.6 0 4 0h9.1c2.4 0 4.2 2.1 4 4.4l-.6 5zM14.1 18h-11c-.8 0-1.5-.7-1.5-1.5S2.3 15 3.1 15h11c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z" />
    </svg>
)
